import { render } from "./CheckLayout.vue?vue&type=template&id=ed7a50ec"
import script from "./CheckLayout.vue?vue&type=script&lang=js"
export * from "./CheckLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__